(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      const searchToggle = this.querySelector('[data-search-toggle]');
      const searchClose = this.querySelector('[data-search-close]');
      const mobileSearch = this.querySelector('[data-mobile-search]');
      if (searchToggle && mobileSearch) {
        searchToggle.addEventListener('click', () => { mobileSearch.classList.add('is-open'); mobileSearch.querySelector('input').focus(); });
      }
      if (searchClose && mobileSearch) {
        searchClose.addEventListener('click', () => { mobileSearch.classList.remove('is-open'); });
      }
      const menuToggle = this.querySelector('[data-menu-toggle]');
      const drawer = document.querySelector('[data-mobile-drawer]');
      const drawerOverlay = document.querySelector('[data-drawer-overlay]');
      const drawerClose = document.querySelector('[data-drawer-close]');
      const openDrawer = () => { if (drawer && drawerOverlay) { drawer.classList.add('is-open'); drawerOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; } };
      const closeDrawer = () => { if (drawer && drawerOverlay) { drawer.classList.remove('is-open'); drawerOverlay.classList.remove('is-open'); document.body.style.overflow = ''; } };
      if (menuToggle) menuToggle.addEventListener('click', openDrawer);
      if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
      if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScrollHandler); }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 10) this.classList.add('nx-is-scrolled'); else this.classList.remove('nx-is-scrolled');
      this.currentScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
